import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=0e8fb614&scoped=true"
import script from "./MyQuotes.vue?vue&type=script&lang=ts"
export * from "./MyQuotes.vue?vue&type=script&lang=ts"
import style0 from "./MyQuotes.vue?vue&type=style&index=0&id=0e8fb614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8fb614",
  null
  
)

export default component.exports